import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getAgreementsService } from "@modules/agreements/services/queries/listAgreements/service";

export const AgreementsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      getOptionLabel={(option: { id?: number; name?: string }) =>
        option?.id !== undefined ? `#${option.id} — ${option.name ?? ""}` : ""
      }
      {...props}
      ref={ref}
      queryHook={getAgreementsService}
    />
  );
});

AgreementsAutocomplete.displayName = "AgreementsAutocomplete";
